import { parseGradientColor } from '@bonanza-social/moonlight/lib/common/Gradient/Gradient.utils';
import { COLOR_TOKENS } from '@bonanza-social/moonlight/lib/theme/index.content';
import { TARGET_GRADIENT_TOKENS } from './SVGGradients.content';

function SVGGradients() {
  return (
    <svg width={0} height={0}>
      <defs>
        {Object.keys(COLOR_TOKENS).map((themeName) => {
          const tokens = COLOR_TOKENS[themeName as keyof typeof COLOR_TOKENS];

          return Object.entries(tokens).map(([variant, color]) => {
            if (!(TARGET_GRADIENT_TOKENS as string[]).includes(variant)) {
              return null;
            }

            const { angle, colors, locations } = parseGradientColor(color);

            return (
              <linearGradient
                key={`${variant}-gradient-${themeName}`}
                id={`${variant}-gradient-${themeName}`}
                rotate={`${angle}deg`}
              >
                {colors.map((color, index) => (
                  <stop
                    key={`${color}-${index}-${themeName}`}
                    offset={`${locations[index] * 100}%`}
                    stopColor={color}
                  />
                ))}
              </linearGradient>
            );
          });
        })}
      </defs>
    </svg>
  );
}

export default SVGGradients;
